export function getCurrrentPlan(state) {
	return state.subscription?.tier?.data?.currentPlan;
}

export function hasSubscription(state) {
	return !!(state.subscription?.details?.data?.status?.toLowerCase() === 'active');
}

export function isNotificationActive(state, name) {
	return state.notification.active.includes(name);
}
